export default '/img/loop/1.jpg';
